const BagIcon = props => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 13 18"
      width="13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.3364 18H0.909091L0 5.12726H13.2455L12.3364 18Z" fill="#283333" />
      <path
        d="M6.6274 0C4.44558 0 2.67285 1.77273 2.67285 3.94546V4.30909H4.35467V3.94546C4.35467 2.69091 5.37285 1.68182 6.61831 1.68182C7.86376 1.68182 8.88194 2.7 8.88194 3.94546V4.30909H10.5638V3.94546C10.5729 1.77273 8.80013 0 6.6274 0Z"
        fill="#283333"
      />
    </svg>
  );
};

export default BagIcon;
